import React from 'react'
import './Controles.scss'

import { NavLink as Link } from 'react-router-dom'

const sizes = ['9px', '13px', '17px', '21px', '26px']

const ROOT = document.querySelector(':root')

class Controles extends React.Component {
    constructor() {
        super()
        this.state = {
            sizeIndex: 1,
            altoContraste: false,
        }
        this.aumentaFonte = this.aumentaFonte.bind(this)
        this.fontePadrao = this.fontePadrao.bind(this)
        this.diminuiFonte = this.diminuiFonte.bind(this)
        this.alternaContraste = this.alternaContraste.bind(this)
    }

    componentDidMount() {
        let prefs = window.sessionStorage.getItem('preferencias')
        if (prefs) {
            Promise.resolve(this.setState(JSON.parse(prefs))).then(() => {
                this.atribuiContraste()
                this.atribuiTamanhoFonte()
            })
        }
    }

    onKeyDownValue(event) {
        if (event.key === 'Enter') {
            this.alternaContraste()
        }
    }

    salvaEstado() {
        window.sessionStorage.setItem('preferencias', JSON.stringify(this.state))
    }

    atribuiContraste() {
        document.body.setAttribute('id', this.state.altoContraste ? 'contraste' : '')
    }

    atribuiTamanhoFonte() {
        ROOT.style.fontSize = sizes[this.state.sizeIndex]
    }

    alternaContraste() {
        Promise.resolve(this.setState({ altoContraste: !this.state.altoContraste })).then(() => {
            this.atribuiContraste()
            this.salvaEstado()
        })
    }

    aumentaFonte() {
        if (this.state.sizeIndex < sizes.length - 1) {
            let novoIndice = this.state.sizeIndex + 1
            Promise.resolve(this.setState({ sizeIndex: novoIndice })).then(() => {
                this.atribuiTamanhoFonte()
                this.salvaEstado()
            })
        }
    }

    fontePadrao() {
        Promise.resolve(this.setState({ sizeIndex: 1 })).then(() => {
            this.atribuiTamanhoFonte()
            this.salvaEstado()
        })
    }

    diminuiFonte() {
        if (this.state.sizeIndex > 0) {
            let novoIndice = this.state.sizeIndex - 1
            Promise.resolve(this.setState({ sizeIndex: novoIndice })).then(() => {
                this.atribuiTamanhoFonte()
                this.salvaEstado()
            })
        }
    }

    vaiPara(item) {
        let elemento = document.getElementById(item)
        if (elemento) {
            elemento.scrollIntoView()
            elemento.focus()
        }
    }

    render() {
        return (
            <nav className="controles">
                <div className="atalhos">
                    <button accessKey="1" tabIndex="0" className="controle-item buttonAccessKeys" onClick={() => this.vaiPara('inicioPrograma')}>
                        conteúdo[1]
                    </button>
                    <button accessKey="2" tabIndex="0" className="controle-item buttonAccessKeys" onClick={() => this.props.toggleMenu(true)}>
                        menu[2]
                    </button>
                    <button accessKey="3" tabIndex="0" className="controle-item buttonAccessKeys" onClick={() => this.vaiPara('campoPesquisar')}>
                        busca[3]
                    </button>
                </div>

                <div className="acessibilidade">
                    <span className="controle-item">
                        <Link to="/acessibilidade">acessibilidade</Link>
                    </span>

                    <div className="fontes">
                        <button className="controle-item buttonTamanhoFonte" title="Aumentar Tamanho do Texto" onClick={this.aumentaFonte}>
                            A+
                        </button>
                        <button className="controle-item buttonTamanhoFonte" title="Tamanho Inicial do texto" onClick={this.fontePadrao}>
                            A
                        </button>
                        <button className="controle-item buttonTamanhoFonte" title="Diminuir Tamanho do Texto" onClick={this.diminuiFonte}>
                            A-
                        </button>
                    </div>

                    <span className="controle-item" title="Aplicar/Remover Alto Contraste">
                        <span>contraste</span>
                        <label className="switch">
                            <input type="checkbox" checked={this.state.altoContraste} onChange={this.alternaContraste} />
                            <span className="slider" tabindex="0" onKeyDown={this.onKeyDownValue.bind(this)}></span>
                        </label>
                    </span>
                    <span className="controle-item">
                        <Link to="/mapaDoSite">mapa do site</Link>
                    </span>
                </div>
            </nav>
        )
    }
}

export default Controles
